import { ServicesApi } from './../../../shared/sdk/services/custom/Services';
import { Observable } from 'rxjs/Observable';
import { KanvasUserApi } from '../../../shared/sdk';
import { RealTime } from './../../../shared/sdk/services/core/real.time';
import { GlobalPropertiesService } from '../../../core.module/services/global-properties.service';
import { LoopBackAuth } from '../../../shared/sdk';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoggerService } from '../../../shared/sdk';
import { LoopBackConfig, FireLoopRef, Services } from '../../../shared/sdk';
import { DataURLS } from '../../../shared/base.url';
import { selector } from 'rxjs/operator/publish';
import { Component, OnInit } from '@angular/core';
import 'rxjs/add/operator/take';

@Component({
  selector: 'app-ping-test',
  templateUrl: './ping-test.component.html',
  styleUrls: ['./ping-test.component.css'],
})
export class PingTestComponent implements OnInit {

  private servicesRef: FireLoopRef<Services>;
  public data: any = {
    testRunning: false,
    workingon: ''
  };
  public results = new Array();
  public username = 'testclient';
  public password = 'testclient';
  public playerid = '';
  public schedule = {};


  constructor(
    private globalPropertiesService: GlobalPropertiesService,
    private servicesApi: ServicesApi,
    private authService: LoopBackAuth,
    private router: Router,
    private toastrService: ToastrService,
    private logger: LoggerService,
    private activatedRoute: ActivatedRoute,
    private realTime: RealTime,
    private kanvasUserApi: KanvasUserApi

  ) {
    LoopBackConfig.setBaseURL(DataURLS.BASE_URL);
    LoopBackConfig.setApiVersion(DataURLS.API_VERSION);
  }

  async ngOnInit() {

  }

  async StartTests() {
    if (!this.username || !this.password) {
      return;
    }

    try {
      this.results = new Array();
      this.data.testRunning = true;

      // first log out current user to do tests without auth
      if (this.kanvasUserApi.isAuthenticated()) {
        await this.kanvasUserApi.logout().toPromise();
      }


      // with auth
      const user = await this.kanvasUserApi.login({ username: this.username, password: this.username, }, 'user', false).toPromise();

      // get schedule test
      this.data.workingon = 'Getting schedule test';
      await this.doSchedule();


      this.data.workingon = `Socket method test...With Authencation. Logged in as '${user.user.email}'`;
      await this.doIO();
      this.data.workingon = `REST API method test...With Authencation. Logged in as '${user.user.email}'`;
      await this.doPing();

      // logout user
      await this.kanvasUserApi.logout().toPromise();

      // no auth tests
      this.data.workingon = 'Socket method test...Unauthencated';
      await this.doIO();
      this.data.workingon = 'REST API method test...Unauthencated';
      await this.doPing();

    } catch (error) {
      this.logger.info(error.message);
    }

    this.data.testRunning = false;
  }

  async doSchedule() {

    let timesTotal = 0;
    this.data.timestart = new Date().getTime();
    this.data.count = 0;
    while (this.data.count < 1000) {
      this.data.count += 1;
      const start = new Date().getTime();
      this.schedule = await this.servicesApi.getSchedule(this.playerid, null).toPromise();
      const end = new Date().getTime();
      this.data.speed = end - start;
      this.data.time = (new Date().getTime() - this.data.timestart);
      timesTotal += this.data.speed;
      const avg = timesTotal / this.data.count;
      this.data.avgtime = avg.toPrecision(2);
    }

    if (this.kanvasUserApi.isAuthenticated()) {
      this.results.push(`Authenticated - Sending/Receiving 1000 SCHEDULE requests - Total Time (Rest Api Method): ${this.data.time}ms avg ${this.data.avgtime}ms`);
    }

  }

  async doIO() {
    const status = await this.realTime.onReady().take(1).toPromise();

    this.realTime.onDisconnect().subscribe((msg) => {
      console.log('realtime disconnect');
    });

    this.realTime.IO.on('disconnect').subscribe((msg, ) => {
      console.log('disconnected');
    });

    this.data.timestart = new Date().getTime();
    this.data.count = 0;
    const times = new Array();

    while (this.data.count < 1000) {
      this.data.count += 1;
      const start = new Date().getTime();
      this.realTime.IO.emit('ping', this.data.count);
      const msg = await this.realTime.IO.on('ping').take(1).toPromise();
      const end = new Date().getTime();
      this.data.speed = end - start;
      this.data.lastPing = msg;
      this.data.time = (new Date().getTime() - this.data.timestart);
      times.push(this.data.speed);
      const sum = times.reduce(function (a, b) { return a + b; });
      const avg = sum / times.length;
      this.data.avgtime = avg.toPrecision(2);
    }

    if (this.kanvasUserApi.isAuthenticated()) {
      this.results.push(`Authenticated - Sending/Receiving 1000 requests - Total Time (Socket Method): ${this.data.time}ms avg ${this.data.avgtime}ms`);
    } else {
      this.results.push(`Sending/Receiving 1000 requests - Total Time (Socket Method): ${this.data.time}ms avg ${this.data.avgtime}ms`);
    }
  }

  async doPing() {
    const times = new Array();
    this.data.timestart = new Date().getTime();
    this.data.count = 0;
    while (this.data.count < 1000) {
      this.data.count += 1;
      const start = new Date().getTime();
      const status = await this.servicesApi.ping().toPromise();
      const end = new Date().getTime();
      this.data.speed = end - start;
      this.data.lastPing = status.result.pong;
      this.data.time = (new Date().getTime() - this.data.timestart);
      times.push(this.data.speed);
      const sum = times.reduce(function (a, b) { return a + b; });
      const avg = sum / times.length;
      this.data.avgtime = avg.toPrecision(2);
    }

    if (this.kanvasUserApi.isAuthenticated()) {
      this.results.push(`Authenticated - Sending/Receiving 1000 requests - Total Time (Rest Api Method): ${this.data.time}ms avg ${this.data.avgtime}ms`);
    } else {
      this.results.push(`Sending/Receiving 1000 requests - Total Time (Rest Api Method): ${this.data.time}ms avg ${this.data.avgtime}ms`);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/core.module/components/ping-test/ping-test.component.ts